import React, { useState, useEffect } from "react";
import styled, { css, createGlobalStyle } from "styled-components";
import Sortable from "./Sortable";
import arrayMove from "array-move";
import produce from "immer";
import { useImages } from "../hooks/useImages";
import { ReactComponent as Check } from "../assets/svg/check.svg";
import { ReactComponent as Wrong } from "../assets/svg/wrong.svg";
import clean from "clean-deep";

const LessonDataDiscoverWord = ({ seed, freeze = false, onChange = () => {} }) => {
  const [state, setState] = useState([]);

  const [extractedImages, setExtractedImages] = useState([]);

  const images = useImages(extractedImages);

  useEffect(() => {
    const state = initState(seed);
    setState(state);
    setExtractedImages(state.map((i) => i.image));
  }, [seed]);

  useEffect(() => {
    onChange({
      ready: true,
      data: clean(state),
    });
  }, [state, onChange]);

  const isLoaded = ({ image }) => (image && images[image]) || !image;

  const onSortEnd = ({ oldIndex, newIndex, indexItem, indexRef }) =>
    setState(
      produce((draftState) => {
        draftState[indexItem].refs[indexRef] = arrayMove(
          draftState[indexItem].refs[indexRef],
          oldIndex,
          newIndex
        );
      })
    );

  const Sentence = ({ sentence, refs, indexItem }) => {
    if (sentence === "" || !sentence) return null;
    const sentences = sentence.split(/\[.+?\]/gi);

    return (
      <SentenceStyled>
        {sentences.map((sentence, index) => {
          return (
            <React.Fragment key={index}>
              {sentence}
              {refs?.[index] && (
                <Sortable
                  pressDelay={0}
                  axis="xy"
                  items={refs[index]}
                  render={(value, index) => (
                    <Letter key={index}>{value}</Letter>
                  )}
                  wrapper={Letters}
                  onSortEnd={(props) =>
                    onSortEnd({ ...props, indexItem, indexRef: index })
                  }
                  helperClass="helperItem"
                />
              )}
            </React.Fragment>
          );
        })}
      </SentenceStyled>
    );
  };

  return (
    <>
      <GlobalStyles />
      <Container freeze={freeze}>
        {state.map((item, index) => (
          <Row key={index} state={item.state}>
            {isLoaded(item) ? (
              <>
                {item.state && <StateIcon as={stateIcon[item.state]} />}
                {item.image && <Image src={images[item.image]} />}
                <Sentence
                  sentence={item.text}
                  refs={item.refs}
                  indexItem={index}
                />
              </>
            ) : (
              <Spinner src="loading.gif" />
            )}
          </Row>
        ))}
      </Container>
    </>
  );
};

const stateIcon = {
  SUCCESS: Check,
  FAILURE: Wrong,
};

const initState = (seed) => {
  let state = formatState(seed);
  return state;
};

const formatState = (state) => state.map((state) => ({ refs: [], ...state }));

const GlobalStyles = createGlobalStyle`

  .helperItem {
    box-shadow: 0 0 7px 5px rgba(0,0,0,0.1);
    border: 2px dashed green;

    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 200;
  }

`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  border-radius: 20px;
  overflow: hidden;
  background-color: white;

  ${(props) =>
    props.freeze &&
    css`
      pointer-events: none;
    `}
`;

const Row = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px 10px;
  :nth-child(2n) {
    background-color: #fafafa;
  }
  & > * {
    margin: 5px;
  }
  ${(props) =>
    props.state &&
    css`
      padding-bottom: 60px;
    `}
`;

const StateIcon = styled.div`
  width: 25px;
  height: 25px;
  min-width: 25px;
  min-height: 25px;
  position: absolute;
  bottom: 18px;
  left: 0px;
  right: 0px;
  margin: 0 auto;
`;

const Letter = styled.div`
  user-select: none;
  font-size: 0.9em;
  background-color: #caedff;
  /*padding: 10px 15px;
  border-radius: 10px;
  margin: 2px;*/
  /* padding: 15px 20px;
  margin: 5px; */
  /* border-radius: 10px; */
  border-radius: 15px;
  padding: 20px 25px;
  margin: 5px;

  cursor: grab;
`;

const Letters = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
`;

const Image = styled.img`
  max-height: 220px;
  border-radius: 20px;
  object-fit: contain;
  box-sizing: border-box;
  max-width: 95%;
  background-color: black;
`;

const SentenceStyled = styled.div`
  font-size: 0.9em;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  width: 100%;
  white-space: pre-wrap;

  user-select: none;
`;

const Spinner = styled.img`
  margin: auto;
  width: 25px;
  height: 25px;
  display: block;
`;

export default LessonDataDiscoverWord;
